export default {
    key: 'weapon',
    label: 'Weapon',
    surname: [
        // Projectile & Ballistic
        'Railgun',
        'Buckshot',
        'Broadside',
        'Ricochet',
        'Barrage',
        'Salvo',
        'Volley',
        'Fusillade',
        'Cannonade',
        'Scattershot',
        'Gauss Rifle',
        'Coilgun',
        'Boltcaster',
        'Flechette',
        'Slugger',
        'Hardshot',
        'Dum-Dum',
        'Tracerburst',
        'Buckshell',
        'Peppercorn',

        // Energy & Plasma
        'Plasmashot',
        'Ion Burst',
        'Arc Bolt',
        'Photon Lance',
        'Laser Pulse',
        'Beam Cannon',
        'Thermal Ray',
        'Radflare',
        'Volt Strike',
        'Fusion Bolt',
        'Maser Beam',
        'Plasma Cutter',
        'Solar Flare',
        'Particle Beam',
        'Charged Lance',
        'Microwave Burst',
        'Gamma Ray',
        'Neutron Beam',
        'Proton Blast',
        'Ion Storm',

        // Explosive & Area
        'Hellfire',
        'Shrapnel',
        'Detonator',
        'Cluster Round',
        'Incendiary',
        'Fragburst',
        'Concussive',
        'Flashbang',
        'Napalm Round',
        'Thermite',
        'Breacher',
        'Bunker Buster',
        'Scatter Mine',
        'Airburst',
        'Proximity Round',
        'White Phosphorus',
        'Firebomb',
        'Splinterhead',
        'Demolisher',
        'Crackershot',

        // Action Verbs / Dynamic
        'Piercer',
        'Shredder',
        'Striker',
        'Blaster',
        'Lacerator',
        'Raker',
        'Splitter',
        'Severer',
        'Ripper',
        'Crusher',
        'Decimator',
        'Pulverizer',
        'Mangler',
        'Wrecker',
        'Grinder',
        'Mulcher',
        'Flayer',
        'Gouger',
        'Pounder',
        'Hammerstrike',
        'Rending Claw',
        'Teardown',

        // Missile & Guided
        'Sidewinder',
        'Tomahawk',
        'Hellbolt',
        'Tracer',
        'Seeker',
        'Homing Round',
        'Warhead',
        'Foxhound',
        'Interceptor',
        'Killshot',
        'Javelin',
        'Longbow',
        'Crossbow',
        'Deadlock',
        'Pinpoint',
        'Smart Round',
        'Fire-and-Forget',
        'Lockdown',
        'Arrowhead',
        'Starfire Missile',

        // Melee / Brawl
        'Razorblade',
        'Clawstrike',
        'Fangbite',
        'Knuckleduster',
        'Ironpunch',
        'Slasher',
        'Maul',
        'Skewer',
        'Haymaker',
        'Bludgeon',
        'Headcracker',
        'Gut Hook',
        'Bonecrusher',
        'Ironjaw',
        'Piledriver',
        'Groundpounder',
        'Cleave',
        'Thrash',
        'Battering Fist',
        'Death Grip',

        // Suppression & Support
        'Suppressor',
        'Overwatch',
        'Pindown',
        'Smokescreen',
        'Suppression Field',
        'Covering Fire',
        'Strafing Run',
        'Fire Blanket',
        'Lock Down',
        'Area Denial',
        'Crossfire',

        // Sci-Fi / Exotic
        'Disruptor',
        'Nullifier',
        'Phase Cannon',
        'Gravity Spike',
        'Warp Spike',
        'Pulse Driver',
        'Shock Coil',
        'Static Burst',
        'Vortex Round',
        'Entropy Bolt',
        'Singularity Gun',
        'Dark Matter Burst',
        'Rift Cannon',
        'Tachyon Lance',
        'Resonance Blaster',
        'Dimensional Spike',
        'Anti-Matter Round',
        'Temporal Pulse',
        'Zero-Point Beam',
        'Void Projector',
    ]
};
